import { Box, Paper, styled } from '@mui/material';

export const InfoSectionWrapper = styled(Box)(() => ({
	display: 'grid',

	flexDirection: 'column',
	gap: '16px',
}));

export const InfoItemWrapper = styled(Paper)(() => ({
	display: 'flex',
	alignItems: 'center',
	gap: '8px,',
	borderRadius: '8px',

	padding: '4px 8px',
}));

export const StyledImage = styled('img')(() => ({
	maxWidth: '55px',

	'&.sm-down-hidden': {
		display: 'none',
	},
}));
